import { render, staticRenderFns } from "./ShowUsers.vue?vue&type=template&id=35d2ffe4&"
import script from "./ShowUsers.vue?vue&type=script&lang=js&"
export * from "./ShowUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports